<template>
    <CustomHeader :text="$t('activityName.active_bonus')" />
    <div class="mainContainer">
        <div class="banner">
            <img v-if="dataSet.flatIcon" :src="dataSet.flatIcon" alt="">
            <img v-else src="@/assets/activeBonus/active_bonus_top_banner.png" alt="">
            <div class="yesterdayCard">
                <van-row>
                    <van-col span="16">
                        <div class="text1">{{ $t('chest.yesterdayBet') }} <span style="color: #ffa200;"> R$
                            </span><span>{{ dataSet.yesterBetAmount }}</span></div>
                        <div class="text2">{{ $t('chest.bonus') }} <span style="color: #ffa200;"> R$ </span><span
                                style="">{{ dataSet.yesterRewardAmount }}</span></div>
                    </van-col>
                    <van-col span="8" class="claimBtn">
                        <img v-if="dataSet.yesterRewardAmount <= 0"
                            src="@/assets/activeBonus/active_bonus_item_disable.png" alt="">
                        <div v-else class="activeClaimBtn" @click="activeBonusClaim">{{ $t('activity.reciev') }}</div>
                    </van-col>
                </van-row>
            </div>
        </div>
        <div class="todayCard">
            <div class="subtodayCard">
                <van-row>
                    <van-col span="20">
                        <div class="text1">{{ $t('chest.todayBet') }} <span style="color: #ffa200;"> R$ </span> <span>{{
                            dataSet.todayBetAmount }}</span></div>
                        <div class="text2">{{ $t('chest.bonus') }} <span style="color: #ffa200;"> R$ </span> <span>{{
                            dataSet.todayRewardAmount }}</span></div>
                    </van-col>
                </van-row>
            </div>
            <van-row class="infoContainer">
                <van-col span="2" style="text-align: right; padding: 0 1%;">
                    <van-icon name="info" color="#ffffffa6" size="18" />
                </van-col>
                <van-col span="1"></van-col>
                <van-col span="21">
                    {{ $t('chest.info', {
                        startTime: dataSet.activityConfig?.claim_start_time, endTime:
                            dataSet.activityConfig?.claim_end_time
                    }) }}
                </van-col>
            </van-row>
        </div>
        <div class="bonusList">
            <div class="listTitle">{{ $t('chest.activeBonusTitle') }}</div>
            <van-row class="tabelhead">
                <van-col span="10" style="color: rgba(255, 255, 255, 0.65);">{{ $t('common.bets') }}</van-col>
                <van-col span="14" style="color: rgba(255, 255, 255, 0.65);">{{ $t('chest.luckBonus') }}</van-col>
            </van-row>
            <van-row v-for="(item, index) in dataSet.rewardList" :key="index" class="tabelRow" :style="{
                backgroundColor: index % 2 === 1 ? '#005655' :'transparent' 
            }">
                <van-col span="10" class="tabelText">R$ {{ item.bet }}</van-col>
                <van-col span="14" class="tabelText"><span>R$ {{ item.reward_coin }}</span></van-col>
            </van-row>
        </div>
        <div class="bottom_text">
            <div class="title">{{ $t("common.activityTitle") }}</div>
            <!-- <div class="line_text" v-for="(item, index) in dataSet.activityIntro" :key="index">
                {{ item }}
            </div> -->
            <ul class="notice_list">
            <li v-for="(item, index) in dataSet.activityIntro" :key="index" v-html="item"></li>
            </ul>
        </div>
    </div>
</template>
<script setup lang="ts">
import CustomHeader from '../components/common/customHeader.vue';
import { ActiveBonusData } from '@/view/activeBonus/supportScript';

const props = defineProps<{
    dataSet: ActiveBonusData
}>()

const emits = defineEmits(['activeBonusClaim'])

const activeBonusClaim = () => {
    emits('activeBonusClaim')
}
</script>
<style scoped>
.mainContainer {
    padding: 60px 0;
    background: #003534;
}

.banner {
    position: relative;
}

.banner img {
    width: 100%;
}

.yesterdayCard {
    background: #005655;
    padding: 10px;
    border-radius: 10px;
    /* border: 2px solid #e4dfdf; */
    position: absolute;
    bottom: -50%;
    right: 5%;
    left: 5%;
}

.todayCard {
    width: 80%;
    margin: 26% 5% 2%;
    padding: 5%;
    background: #005655;
    /* border: 2px solid #ffcea6; */
    border-radius: 10px;
}

.subtodayCard {
    width: 90%;
    padding: 3%;
    background-image: #393266;
    border-radius: 10px;
}

.text1 {
    font-size: 15px;
    color: #fff;
    padding: 3.5% 5%;

}

.text2 {
    font-size: 15px;
    color: #fff;
    padding: 3.5% 5%;
    font-weight: bold;
}

.text2 span {
    font-size: 18px;
    color: #ffa200;
}

.text1 span {
    color: #ffa200;
}

.claimBtn {
    display: flex;
    align-items: center;
}

.claimBtn img {
    width: 100%;
}

.activeClaimBtn {
    padding: 10%;
    border-radius: 30px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(rgb(255, 194, 113) 0%, rgb(242, 145, 13) 100%);
    color: #fff;
    font-weight: 700;
    /* border: .02667rem solid #fd66b1;     */
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
}

.infoContainer {
    padding: 10px 0;
    color: #ffffffa6;
    font-size: 11.5px;
    display: flex;
    align-items: center;
}

.bonusList {
    padding: 2% 5%;
    color: #fff;
    /* margin: 0 15px; */
    border-radius: 10px;
}

.listTitle {
    padding: 15px 5px;
    /* background: #1a223a; */
    /* border-radius: 15px 15px 0px 0; */
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    /* border-bottom: 1px solid #ffffff26; */
}

.tabelhead {
    background-color: #005655;
    padding: 15px;
    /* font-weight: bold; */
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
}

.tabelRow {
    padding: 15px;
    font-size: 12px;
    text-align: center;
}

.tabelText {
    padding: 0 10px;

}

.tabelText span {
    padding: 0 5px;
    color: #FBA531;
    font-weight: 800;
    font-size: 15px;
}

.bottom_text {
    padding: 35px 35px 35px;
    background: rgb(0, 33, 33);
    padding: 10px;
    border-radius: 10px;
    margin: 10px 15px 0px;
}

.title {
    color: #fff;
    font-weight: bold;
    font-size: 15px;
    padding: 10px 0;
}

.line_text {
    color: #6b6f79;
    font-size: 13px;
    padding: 5px;
}

.notice_list {
    padding: 10px 15px 0px;
}

.notice_list li {
  color: rgba(255, 255, 255, .6);
  font-size: 14px;
  line-height: 1.4;
  margin-bottom: 10px;
  font-weight: 500;

  word-break: break-all;       
  overflow-wrap: break-word; 
}

@media (min-width: 480px) {
    .tabelhead {
        font-size: 17px;
    }

    .tabelRow {
        font-size: 15px;
    }

    .listTitle {
        font-size: 20px;
    }

    .infoContainer {
        font-size: 13px;

    }

    .text1 {
        font-size: 17px;
    }

    .text2 {
        font-size: 17px;
    }

    .title {
        font-size: 17px;
    }

    .line_text {
        font-size: 15px;
    }
}

@media (min-width: 600px) {}

@media (min-width: 1920px) {}
</style>